<template>
  <div class="dh-player">
    <div ref="DHVideoIntercomPlayer" class="dh-player-main-box DHVideoPlayer DHvideoPlayerIntercom" id="DHVideoPlayer"></div>
  </div>
</template>

<script>
import '../../tool/videoPlayerIntercom'
var oVideoIntercomControl = null
export default {
  name: 'DHPlayer',
  props: {
    currentToken: {
      type: String,
    },
    currentDeviceId: {
      type: String,
    },
  },
  data () {
    return {}
  },
  created() {},
  mounted() {
    if (!oVideoIntercomControl || !oVideoIntercomControl.event) {
      this.daHuaPlayerInitPlayer()
      this.daHuaPlayerInit()
    } else {
      this.daHuaPlayerCreateVideo()
    }
  },
  methods: {
    // 启动应用程序
    daHuaPlayerPulseOn () {
      let startECloudCtrlServer = window.sessionStorage.getItem('startECloudCtrlServer')
      if (!startECloudCtrlServer) {
        window.sessionStorage.setItem('startECloudCtrlServer', 'start')
        let eleLink = document.createElement('a');
        eleLink.style.display = 'none';
        eleLink.href = 'ECloudCtrlServer://'
        document.body.appendChild(eleLink);
        eleLink.click();
        document.body.removeChild(eleLink);
      }
    },

    daHuaPlayerInit () {
      oVideoIntercomControl.init()
    },

    daHuaPlayerInitPlayer () {
      let rect = this.$refs.DHVideoIntercomPlayer.getBoundingClientRect()
      const eWidth = rect.width
      const eHeight = rect.height
      let _self = this
      oVideoIntercomControl = new videoPlayerIntercom({
        videoClassName: 'DHVideoPlayer', //视频id
        width: eWidth,
        height: eHeight,
        connectSuccess: function () {
          console.log('初始化成功')
          _self.daHuaPlayerCreateVideo()
        },
        connectError: function(e){
          console.log(e)
        },
        connectClose:function(){
          oVideoIntercomControl = null
        }
      })
    },

    // 创建视频窗口（内嵌式）
    daHuaPlayerCreateVideo() {
      let scrollWidth = document.body.scrollWidth
      let scrollHeight = document.body.scrollHeight
      let rect = this.$refs.DHVideoIntercomPlayer.getBoundingClientRect()
      let left = rect.left
      let top = rect.top
      let right = rect.left + rect.width
      let bottom = rect.top + rect.height
      console.log(left, top, right, bottom)
      oVideoIntercomControl.event.create({
        left: left,
        top: top,
        right: right,
        bottom: bottom,
        mount: true,
        windowType: '1',
        num: 1
      }, e => {
        if (e.success) {
          this.daHuaPlayerAssignLivePreviewPlayback()
        }
      })
    },

    // 销毁视频窗口（内嵌式）
    daHuaPlayerDestroyVideo() {
      oVideoIntercomControl.event.destroy()
    },

    // 实时预览播放 （带pluginId）
    daHuaPlayerAssignLivePreviewPlayback() {
      let token = this.currentToken
      let deviceId = this.currentDeviceId
      oVideoIntercomControl.event.realmonitor({
        bDefinitionMode: false,
        deviceId: deviceId,
        token: token,
        channelId: '0',
      })
    },

    // 开始视频对讲
    daHuaPlayerStartTalk (token, deviceId) {
      oVideoIntercomControl.event.startTalk({
        deviceId: deviceId,
        token: token,
      })
    },

    // 关闭视频对讲
    daHuaPlayerStopTalk () {
      oVideoIntercomControl.event.stopTalk({})
    },
  },

  beforeDestroy () {
    this.daHuaPlayerDestroyVideo()
  }
}
</script>

<style scoped lang="less">
.dh-player {
  width: 100%;
  height: 100%;
  .DHVideoPlayer {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DHPlayer/DHPlayer.vue